// extracted by mini-css-extract-plugin
export var noSpinners = "_mt-6";
export var percentageInput = "_mt-7";
export var variantColor1 = "_mt-0";
export var variantColor2 = "_mt-1";
export var variantColor3 = "_mt-2";
export var variantColor4 = "_mt-3";
export var variantColor5 = "_mt-4";
export var variantColor6 = "_mt-5";